import React from 'react';
import Editor from '../../Editor';
import { EditorProps } from '../../types';
import cn from 'classnames';
import { extConfig } from './config';

import viewerStyles from '../../../Viewer/presets/CustomBox/CustomBox.scss';
import s from './CustomBox.scss';

const CustomBoxEditor: React.FC<
  Omit<EditorProps, 'extensionConfig' | 'presetId'>
> = props => {
  return (
    <>
      <Editor
        {...props}
        withinModal
        presetId="custombox"
        className={cn(s['root'], viewerStyles['root'])}
        extensionConfig={extConfig}
      ></Editor>
    </>
  );
};
CustomBoxEditor.displayName = 'CustomBoxEditor';

export default CustomBoxEditor;
